export default "__VITE_ASSET__e99d11ee__"